module.exports = __webpack_public_path__ + "img/machineLearning.ee260d92.png";